// Reference plates — extra territorial & planning documents.
// Kept separate from the region atlas; opened via MASTER PLAN.
export const PLATES = [
  {
    id: "plate-master-plan",
    name: "Master Plan",
    note: "28 states + 8 union territories · 1,008 hectares · one India, endless experiences",
    image: "/images/plate-master-plan.webp",
  },
  {
    id: "plate-landlocked",
    name: "Master Plan — Landlocked Version",
    note: "All water bodies artificially created · state-wise and UT area allocation",
    image: "/images/plate-landlocked.webp",
  },
  {
    id: "plate-locations",
    name: "Potential Locations — Five Sites",
    note: "Jewar · Nagaur · Dhar–Indore · Shirpur–Dhule · Chitradurga",
    image: "/images/plate-locations.webp",
  },
];
